export default "__VITE_ASSET__c25b5857__"